export default __webpack_public_path__ + "static/media/terminalCode.3e918734.png";